module.exports = new __parcel__URL__("suggestions.tpl.52cb06d0.svg").toString();